export default __webpack_public_path__ + "static/media/git-.c0ad6253.svg";